import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { StatusBannerSurface } from "api/rpc/2024-04/masterAdmin/statusBanner";
import { useStatusBanners } from "hooks/useStatusBanners";
import { statusBannerTypeLabel } from "./statusBannerConstants";
import "./statusBanner.scss";

interface IStatusBannerStackProps {
  surface: StatusBannerSurface;
}

export default function StatusBannerStack(props: IStatusBannerStackProps) {
  const { surface } = props;
  const { t } = useTranslation();
  const { banners, dismiss } = useStatusBanners(surface);

  if (banners.length === 0) {
    return null;
  }

  return (
    <div className="status-banner-stack" role="alert" aria-live="polite">
      {banners.map(banner => (
        <div key={banner.id} className={`status-banner status-banner--${banner.severity}`}>
          <div className="status-banner__body">
            <span className="status-banner__type">{t(statusBannerTypeLabel(banner.type))}</span>
            {banner.title ? <span className="status-banner__title">{banner.title}</span> : null}
            <span className="status-banner__message">{banner.message}</span>
            {banner.link_url ? (
              <a
                className="status-banner__link"
                href={banner.link_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {banner.link_label || t("Learn more")}
              </a>
            ) : null}
          </div>
          {banner.is_dismissible ? (
            <button
              type="button"
              className="status-banner__dismiss"
              aria-label={t("Dismiss")}
              onClick={() => dismiss(banner.id)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
